import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAllEventSystems, selectTotalEventSystems } from '../../../data-services/stores/selectors/event-systems.selectors';
import { EventSystemActions } from '../../../data-services/stores/actions/event-system.actions';
import { LoadingComponent } from '../../../loading/feature/loading.component';
import { CommonModule } from '@angular/common';
import { EventSystemHeadlineComponent } from '../../headline/feature/headline.component';
import { tap } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-event-system-list',
  imports: [LoadingComponent,CommonModule,EventSystemHeadlineComponent],
  templateUrl: '../ui/list.component.html',
  styleUrl: '../ui/list.component.css'
})
export class EventSystemListComponent implements OnInit{
  private readonly _store = inject(Store)
  private readonly _titleService = inject(Title);
  eventSystems$ = this._store.select(selectAllEventSystems)
  eventSystemsTotal$ = this._store.select(selectTotalEventSystems).subscribe();

  ngOnInit(): void {
    this._store.dispatch(EventSystemActions.loadEventSystems());  
    this._titleService.setTitle('LRPTickets.co.uk | Our Event Systems')
  }
}
